var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72501 8.77491V13.4998H2.70006C1.20831 13.4998 0 14.708 0 16.1998V29.6998C0 31.1914 1.20831 32.3996 2.70006 32.3996H24.2998C25.7915 32.3996 27 31.1914 27 29.6998V16.1998C27 14.708 25.7915 13.4998 24.2998 13.4998H22.275V8.77491C22.275 3.92858 18.3462 0 13.5 0C8.65382 0 4.72501 3.92851 4.72501 8.77491ZM8.10003 13.4998V8.77491C8.10003 5.7915 10.5164 3.37487 13.4999 3.37487C16.4834 3.37487 18.9 5.7915 18.9 8.77491V13.4998H8.10003ZM10.7999 20.9248C10.7999 19.4331 12.0082 18.2249 13.4999 18.2249C14.9917 18.2249 16.1998 19.4331 16.1998 20.9248C16.1998 21.8766 15.707 22.7137 14.9647 23.1929C14.9647 23.1929 15.2284 24.7862 15.525 26.6623C15.525 27.2224 15.0728 27.6746 14.5125 27.6746H12.4874C11.9271 27.6746 11.475 27.2224 11.475 26.6623L12.0353 23.1929C11.293 22.7137 10.7999 21.8766 10.7999 20.9248Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.59eea648.svg";
export { ForwardRef as ReactComponent };